// extracted by mini-css-extract-plugin
export default {"header":"ngo-landing_header__dkYbv","title":"ngo-landing_title__7nJRL","btnContainer":"ngo-landing_btnContainer__hIq2A"};